import { resolveComponent as _resolveComponent, withKeys as _withKeys, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, withModifiers as _withModifiers, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "main" }
const _hoisted_2 = { class: "main-form" }
const _hoisted_3 = { class: "main-table" }
const _hoisted_4 = { class: "btns" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_popconfirm = _resolveComponent("el-popconfirm")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_config_provider = _resolveComponent("el-config-provider")!
  const _component_Edit = _resolveComponent("Edit")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_el_form, {
        inline: true,
        ref: "ruleFormRef",
        model: _ctx.form,
        onSubmit: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["prevent"])),
        class: "demo-form-inline"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_form_item, {
            label: "标题",
            prop: "keyword"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: _ctx.form.keyword,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.keyword) = $event)),
                onKeyup: _withKeys(_ctx.onSubmit, ["enter","native"]),
                placeholder: "请输入"
              }, null, 8, ["modelValue", "onKeyup"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "岗位类型",
            prop: "posTypeId"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_select, {
                modelValue: _ctx.form.posTypeId,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.posTypeId) = $event)),
                placeholder: "请选择"
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.posType, (item, index) => {
                    return (_openBlock(), _createBlock(_component_el_option, {
                      label: item.title,
                      value: item.id,
                      key: index
                    }, null, 8, ["label", "value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, null, {
            default: _withCtx(() => [
              _createVNode(_component_el_button, {
                type: "primary",
                onClick: _ctx.onSubmit
              }, {
                default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                  _createTextVNode("搜索", -1)
                ]))]),
                _: 1
              }, 8, ["onClick"]),
              _createVNode(_component_el_button, {
                type: "",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.resetForm(_ctx.ruleFormRef)))
              }, {
                default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                  _createTextVNode("重置", -1)
                ]))]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["model"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: _ctx.addClick
        }, {
          default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
            _createTextVNode("新 增", -1)
          ]))]),
          _: 1
        }, 8, ["onClick"])
      ]),
      _createVNode(_component_el_table, {
        data: _ctx.tableData,
        style: {"width":"100%"},
        "row-class-name": _ctx.tableRowClassName
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_table_column, {
            type: "index",
            width: "80",
            label: "序号"
          }),
          _createVNode(_component_el_table_column, {
            prop: "title",
            label: "展厅名称",
            width: ""
          }),
          _createVNode(_component_el_table_column, {
            prop: "wages",
            label: "薪资"
          }),
          _createVNode(_component_el_table_column, {
            prop: "description",
            label: "描述"
          }),
          _createVNode(_component_el_table_column, {
            prop: "urgencyStatus",
            label: "是否急招"
          }, {
            default: _withCtx(({ row }) => [
              _createTextVNode(_toDisplayString(row.urgencyStatus === 1?'是':'否'), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            prop: "linkUrl",
            label: "跳转链接"
          }),
          _createVNode(_component_el_table_column, {
            prop: "sortNum",
            label: "排序号"
          }),
          _createVNode(_component_el_table_column, {
            prop: "createTime",
            label: "创建时间"
          }),
          _createVNode(_component_el_table_column, {
            prop: "sortNum",
            label: "操作"
          }, {
            default: _withCtx(({ row, $index }) => [
              _createVNode(_component_el_popconfirm, {
                "confirm-button-text": "是",
                "cancel-button-text": "否",
                icon: _ctx.InfoFilled,
                "icon-color": "red",
                title: "确认删除该条数据？",
                onConfirm: ($event: any) => (_ctx.confirmEvent(row, $index))
              }, {
                reference: _withCtx(() => [
                  _createVNode(_component_el_button, { type: "text" }, {
                    default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                      _createTextVNode("删除", -1)
                    ]))]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["icon", "onConfirm"]),
              _createVNode(_component_el_button, {
                type: "text",
                onClick: ($event: any) => (_ctx.editClick(row))
              }, {
                default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                  _createTextVNode("编辑", -1)
                ]))]),
                _: 1
              }, 8, ["onClick"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["data", "row-class-name"]),
      _createVNode(_component_el_config_provider, { locale: _ctx.locale }, {
        default: _withCtx(() => [
          _createVNode(_component_el_pagination, {
            currentPage: _ctx.form.pageNum,
            "page-size": _ctx.form.pageSize,
            "page-sizes": [10, 20, 50, 100],
            small: _ctx.small,
            disabled: _ctx.disabled,
            background: "",
            layout: "total, sizes, prev, pager, next, jumper",
            total: _ctx.total,
            onSizeChange: _ctx.handleSizeChange,
            onCurrentChange: _ctx.handleCurrentChange
          }, null, 8, ["currentPage", "page-size", "small", "disabled", "total", "onSizeChange", "onCurrentChange"])
        ]),
        _: 1
      }, 8, ["locale"]),
      (_ctx.dialogVisible)
        ? (_openBlock(), _createBlock(_component_Edit, {
            key: 0,
            open: _ctx.dialogVisible,
            row: _ctx.rows,
            onClose: _ctx.close
          }, null, 8, ["open", "row", "onClose"]))
        : _createCommentVNode("", true)
    ])
  ]))
}